<p-tabs [(value)]="activeIndex">
  <p-tablist>
    @for (tab of tabs.toArray(); let i = $index; track tab.label()) {
      <p-tab [value]="i" (click)="selectTab(i)" [disabled]="tab.disabled()">
        {{ tab.label() }}
      </p-tab>
    }
  </p-tablist>

  <p-tabpanels>
    @for (tab of tabs.toArray(); track tab.label(); let i = $index) {
      <p-tabpanel [value]="i">
        <ng-container *ngTemplateOutlet="tab.content"></ng-container>
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
